import React from 'react'
import { Field } from 'redux-form'
import { TextField } from '@foodsby/nutrient'
import { email, required } from 'redux-form-validators/lib'
import { Submitting } from '../common/Submitting'

const LoginButton = () => (
  <button type="submit" id="submit" tabIndex="4" className="primary">
    Login
  </button>
)

const LoginForm = ({ handleSubmit, submitting, toggleVisibility }) => (
  <form onSubmit={handleSubmit} gtm-data-elm-id="LoginForm">
    <div className="row start-xs">
      <div className="col-xs-12">
        <Field
          id="userName"
          name="userName"
          type="email"
          tabIndex="1"
          component={TextField}
          label="Email Address *"
          validate={[
            required({ msg: `Email is required` }),
            email({ msg: `Enter a valid email` })
          ]}
        />
      </div>
      <div className="col-xs-12 _lr-hide">
        <div className="col end-xs showPassword">
          <button
            type="button"
            className="link"
            tabIndex="3"
            onClick={toggleVisibility}
          >
            Show Password
          </button>
        </div>
        <Field
          id="loginPassword"
          name="password"
          tabIndex="2"
          type="password"
          className="confirmPassword"
          component={TextField}
          label="Password *"
          validate={[required({ msg: `Password is required` })]}
        />
      </div>
      <div className="col-xs-12 center-xs login-button-container">
        {submitting ? <Submitting /> : <LoginButton />}
      </div>
    </div>
  </form>
)

export default LoginForm
